<template>
  <!--Evento emitido ao clicar no componente
      @event click
   -->

  <!--Evento emitido ao usuário interagir com o componente
      @event change
      @property {number} value - Valor atual do slider
   -->
  <v-range-slider
    class="zoox-component zoox-slider"
    :thumb-size="thumbSize"
    :color="color"
    :track-color="trackColor"
    :track-fill-color="fillColor"
    :label="label"
    :disabled="disabled"
    :min="min"
    :max="max"
    :value="value"
    :ticks="ticks"
    :thumb-color="thumbColor"
    :thumb-label="thumbLabel"
    :append-icon="appendIcon"
    :prepend-icon="prependIcon"
    @click="$emit('click')"
    @input="$emit('change', $event)"
  >
    <template v-if="!hideAppend" #append>
      <!--@slot Slot genérico para modificar o conteúdo em frente do componente -->
      <slot name="append">
        <!--Evento emitido ao clicar no icone em frente do slider 
            @event click:append
        -->
        <z-icon @click="$emit('click:append')"> {{ appendIcon }} </z-icon>
      </slot>
    </template>
    <template v-if="!hidePrepend" #prepend>
      <!--@slot Slot genérico para modificar o conteúdo atrás do componente -->
      <slot name="prepend">
        <!--Evento emitido ao clicar no icone atrás do slider 
            @event click:prepend
        -->
        <z-icon @click="$emit('click:prepend')"> {{ prependIcon }} </z-icon>
      </slot>
    </template>
    <template v-if="$scopedSlots['thumb-label']" #thumb-label="{value}">
      <!--@slot Slot para modificar o conteúdo da thumb 
          @binding {string, number} value valor do slider
  -->
      <slot name="thumb-label" :value="value">
        <span>{{ value }}</span>
      </slot>
    </template>
  </v-range-slider>
</template>

<script>
/**
 * @displayName Range Slider
 */
export default {
  name: 'ZRangeSlider',
  model: {
    event: 'change',
  },
  props: {
    /**
     * Label do slider
     */
    label: {
      type: String,
      required: false,
      default: undefined,
    },

    /**
     * Cor do slider. Usada para a THUMB e o FILL.
     *
     */
    color: {
      type: String,
      required: false,
      default: 'primary',
    },

    /**
     * Cor da thumb do slider
     */
    thumbColor: {
      type: String,
      required: false,
    },
    /**
     * Tamanho da thumb do slider
     */
    thumbSize: {
      type: [String, Number],
      required: false,
      default: 20,
    },
    /**
     * Adiciona "thumb-label" ao longo do slider.
     *
     * Use "always" para sempre mostra-lá
     */
    thumbLabel: {
      type: [Boolean, String],
      required: false,
      default: false,
    },
    /**
     * Especifica o valor minimo do slider
     */
    min: {
      type: [String, Number],
      required: false,
      default: 0,
    },
    /**
     * Especifica o valor máximo do slider
     */
    max: {
      type: [String, Number],
      required: false,
      default: 100,
    },
    /**
     * Flag para desabilitar o slider
     */
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    /**
     * Determina o valor do slider
     */
    value: {
      type: [Number, String, Array, Object],
      required: false,
    },
    /**
     * Adiciona "ticks" ao longo do slider
     */
    ticks: {
      type: [Boolean, String],
      required: false,
      default: false,
    },
    /**
     * Cor do track do slider
     */
    trackColor: {
      type: String,
      required: false,
      default: 'var(--black-050)',
    },
    /**
     * Cor a ser preenchida pelo slider
     */
    fillColor: {
      type: String,
      required: false,
    },
    /**
     * Ícone a ser colocado no início do slider
     */
    prependIcon: {
      type: String,
      required: false,
      default: '$remove_rounded',
    },
    /**
     * Ícone a ser colocado no final do slider
     */
    appendIcon: {
      type: String,
      required: false,
      default: '$add_rounded',
    },
    /**
     * Flag para esconder o ícone de adicionar
     */
    hideAppend: {
      type: Boolean,
      required: false,
      default: false,
    },

    /**
     * Flag para esconder o ícone de remover
     */
    hidePrepend: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
}
</script>

<style lang="scss">
.zoox-slider {
  .v-slider__thumb {
    width: 25.37px;
    height: 24px;
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.25);

    &::before {
      display: none;
    }
  }
  .v-slider--horizontal {
    .v-slider__track-container {
      height: 3.29px;
    }
  }

  .v-slider__thumb-label-container {
    left: 6px !important;

    .v-slider__thumb-label {
      background: transparent !important;
      color: var(--black) !important;
      transform: translateY(-90%) translateX(-50%) rotate(45deg) !important;
    }
  }
}
</style>
